import React, { Component } from 'react'
import BannerImg from '../../../../../assets/images/banners-cartao/banner-estreito.png'
import BannerImgMobile from '../../../../../assets/images/banners-cartao/banner-estreito-mobile.png'
import { isMobile } from '../../../../../src/helpers/window.helper'
import { Box } from './banner.style'

class Banner extends Component {
	constructor(props) {
		super(props)
	}

	render() {
		return (
			<Box>
				<img
					src={isMobile() ? BannerImgMobile : BannerImg}
					alt="Meu Cartão"
				/>
			</Box>
		)
	}
}

export default Banner
